import useForm from "../../lib/refine/useForm";
import { useGo } from "@refinedev/core";
import { Button } from "antd";
import Form from "../../lib/Form";
import { Input } from "../../components/Inputs";
import { Body, Overline } from "../../components/Layout/typography";
import { FormContent } from "../../components/Layout/forms";
import { OnboardingContent } from "../../components/Layout/template";
import { YumyIconCheckGreen } from "../../components/YumyIcons";

export default function CreateRestaurant() {
  const go = useGo();
  const { formProps } = useForm({
    resource: "restaurants",
    action: "create",
    successNotification: "Restaurant has been created",
    onMutationSuccess: ({ data: { id } }) => {
      go({ to: `/onboarding/restaurant/${id}/menu/create` });
    },
  });
  const name = Form.useWatch("name", formProps.form);
  const valid = name && name.trim() !== "";
  return (
    <OnboardingContent>
      <div>
        <Overline lg textCenter>
          Velkommen til yumy
        </Overline>
        <h1>Tilføj din første restaurant</h1>
      </div>
      <Body md gray48>
        Gør dig klar til at bringe din restaurant ind i fremtidens spisning!
      </Body>
      <FormContent onboarding>
        <Form {...formProps} initialValues={{ name: "" }}>
          <Input
            label="Restaurant navn*"
            name="name"
            placeholder="Hvad hedder din restaurant?"
            suffix={valid ? <YumyIconCheckGreen /> : <span />}
          />
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            className="large"
            disabled={!valid}
          >
            Tilføj Restaurant
          </Button>
        </Form>
      </FormContent>
    </OnboardingContent>
  );
}
